import { Stack, Typography } from "@mui/material";

import Image from "next/image";
import { GIFS, WEB_COLORS } from "@/lib/constants";
import ModalComponent from "./Modal";
import ButtonComponent from "./Button";
import React from "react";

const PollingModal = ({
  open,
  handleModal,
  btnOnClick,
  label,
  sublabel,
  text,
  showBtn = true,
  closeButtonRequired = false,
  btnLabel,
  btnDisabled = false,
}) => {
  return (
    <ModalComponent
      // maxWidth="md"
      open={open}
      extraFunction={() => {}}
      closeButtonRequired={closeButtonRequired}
      handleModal={handleModal}>
      <Stack
        gap={2}
        alignItems="center"
        flexDirection={"column"}
        py={{ xs: 1, md: 2 }}
        px={{ xs: 0, md: 2 }}>
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: { xs: "80%", sm: "90%", md: "463px" },
            height: "auto",
          }}>
          <Image
            src={GIFS.loader}
            width={216}
            height={191}
            alt="loader"
            style={{
              scale: "1.4",
              width: "100%",
              maxWidth: "200px",
              height: "auto",
            }}
          />
        </Stack>

        <Stack
          sx={{ flex: 1 }}
          width={{ md: "90%", xs: "100%" }}
          alignItems="center"
          justifyContent="center"
          textAlign={"center"}>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={700}
            fontSize={{ xs: "18px", md: "24px" }}
            color={WEB_COLORS.black}
            mb={1}>
            {label}
          </Typography>

          <Typography
            display={sublabel ? "block" : "none"}
            textAlign={{ xs: "center" }}
            fontWeight={400}
            fontSize={{ xs: "14px", md: "16px" }}
            color={WEB_COLORS.lightShade1}
            mb={1}>
            {sublabel}
          </Typography>

          <Typography
            display={text ? "block" : "none"}
            textAlign={{ xs: "center" }}
            fontWeight={400}
            fontSize={{ xs: "14px", md: "16px" }}
            color={WEB_COLORS.lightShade1}
            mb={2}>
            {text}
          </Typography>
        </Stack>

        {showBtn && (
          <ButtonComponent
            sx={{
              width: { xs: "100%", sm: "80%", md: "275px" },
              height: "48px",
              textTransform: "capitalize",
            }}
            onClick={btnOnClick}
            disabled={btnDisabled}
            type="button">
            {React.isValidElement(btnLabel) ? btnLabel : "Okay"}
          </ButtonComponent>
        )}
      </Stack>
    </ModalComponent>
  );
};

export default PollingModal;
